export const ADVANCED_SEARCH_PATH = 'advanced-search-v2';
export const ADVANCED_SEARCH_FEATURE_TOGGLE = 'Advanced-Search-NewAPI-11282236';
